import dayjs from 'dayjs';

import { LAB_BOOKING_OFFSET } from '@Components/print-prescription/constant';
import { ILabTestData } from '@Reducers/patient';
import { IFulfillment } from '@Reducers/patientFulfillments/types';
import { FulfillmentStatus } from '@Reducers/patientFulfillments/types';
import { LOG_ERROR } from '@Utils/logger';

export const getLabTests = (labTestOrders = []) => {
  const labTests = [];
  for (const labTest of labTestOrders) {
    const formattedLabTest = {
      id: labTest?.labTest?.id,
      name: labTest?.labTest?.name,
      type: labTest?.labTest?.type,
      instructions: labTest?.instructions,
      inclusions: labTest?.labTest?.inclusions,
      preparation: labTest?.labTest?.preparation,
      note:
        (labTest?.labTest?.notes && JSON.parse(labTest?.labTest?.notes)) ||
        'Your required diagnostic tests will be scheduled for you as per your convenience.',
      isVerified: labTest?.labTest?.isVerified,
      venue: labTest?.labTest?.venue,
      specialization: labTest?.labTest?.specialization,
      dueDate: labTest?.dueDate,
      expectedTat: labTest?.labTest?.expectedTat,
    };
    labTests.push(formattedLabTest);
  }
  return labTests;
};

export const allowedToBookLabFulfillment = (fulfillment: IFulfillment) => {
  if (fulfillment.status === FulfillmentStatus.PENDING && fulfillment?.dueDate)
    return dayjs(fulfillment?.dueDate).toDate() <= dayjs().add(LAB_BOOKING_OFFSET, 'minute').toDate();
  return true;
};

// Function to extract max days from TAT string like "1-2 days" or "5-6days"
const extractMaxDaysFromTat = (tat: string | null | undefined): number => {
  if (!tat) return;

  const matches = tat.match(/(\d+)-(\d+)/);
  if (matches && matches.length >= 3) {
    return Number.parseInt(matches[2], 10);
  }

  return;
};

// Function to get the TAT with highest max value from all lab tests
export const getMaxLabEstimate = (labTests?: ILabTestData[]): string | undefined => {
  if (!labTests?.length) return;

  try {
    let maxTat: string | undefined;
    let maxDays = -1;

    for (const test of labTests) {
      const tat = test?.expectedTat;
      const days = extractMaxDaysFromTat(tat);

      if (!!days && days > maxDays) {
        maxDays = days;
        maxTat = tat;
      }
    }

    return maxTat;
  } catch (error) {
    LOG_ERROR('Error: getMaxLabEstimate', error);
    return;
  }
};
